/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_ModelInputs */

const en_ai_model = /** @type {(inputs: Ai_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model`)
};

const de_ai_model = /** @type {(inputs: Ai_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modell`)
};

/**
* | output |
* | --- |
* | "Model" |
*
* @param {Ai_ModelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_model = /** @type {((inputs?: Ai_ModelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_ModelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_model(inputs)
	return en_ai_model(inputs)
});